<script setup lang="ts">
import type { SpotManualData } from 'types/blocks';

defineProps<{
  data: SpotManualData;
}>();
</script>

<template>
  <div class="grid grid-cols-12">
    <div
      v-if="data?.title || data?.description"
      class="col-span-12 lg:col-span-8"
    >
      <h2
        v-if="data?.title"
        class="mb-4 lg:mb-8"
      >
        {{ data.title }}
      </h2>
      <p v-if="data?.description">{{ data?.description }}</p>
    </div>

    <div class="col-span-12 mt-8 grid gap-8 sm:grid-cols-2 lg:mt-16 lg:grid-cols-3">
      <div
        v-for="(spot, index) in data?.spotPicker"
        :key="`spot-${index}`"
      >
        <PartialsSpotManualItem :spot="spot.content" />
      </div>
    </div>
  </div>
</template>
